export const CDN_DOMAIN = 'https://cdn.rotormine.chipsa.ru';

export const fromCDN = (path: string) =>
    process.env.NODE_ENV === 'production' && process.env.NEXT_PUBLIC_ENV === 'production' ? CDN_DOMAIN + path : path;
